<template>
  <GalleryDesktopThumbnail
    :aria-label
    :disabled
    :is-active
    @select="emit('select')"
  >
    <div class="relative">
      <slot name="default" />
      <span
        aria-hidden="true"
        class="pointer-events-none absolute inset-0 flex items-center justify-center"
      >
        <span
          class="flex h-32 w-32 items-center justify-center rounded-full bg-surface-default-hi"
          data-test="gallery-desktop-thumbnail-video-play-button"
          data-testid="gallery-desktop-thumbnail-video-play-button"
        >
          <IconMediaPlay size="20" />
        </span>
      </span>
    </div>
  </GalleryDesktopThumbnail>
</template>

<script setup lang="ts">
import { IconMediaPlay } from '@ds/icons/IconMediaPlay'

import GalleryDesktopThumbnail from '../GalleryDesktopThumbnail/GalleryDesktopThumbnail.vue'

withDefaults(
  defineProps<{
    isActive?: boolean
    disabled?: boolean
    ariaLabel?: string
  }>(),
  {
    isActive: false,
    disabled: false,
    ariaLabel: undefined,
  },
)

const emit = defineEmits<{
  (e: 'select'): void
}>()
</script>
